import { render, staticRenderFns } from "./TransactionTabDataTable.vue?vue&type=template&id=8697cf58"
import script from "./TransactionTabDataTable.vue?vue&type=script&lang=js"
export * from "./TransactionTabDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports